// @ts-ignore: autogenerated import
import type * as Types from '../../../types/global';

import { gql } from '@apollo/client';
import { ArticleItemResultsItemFragmentDoc } from '../../__generated__/ArticleItemResultsItem.generated';
export type SearchResultsFragment = {
	__typename?: 'ArticlesConnection';
	edges: Array<{
		__typename?: 'ArticlesEdge';
		node?: {
			__typename?: 'Article';
			capability: Types.Capability;
			id: string;
			modulesTypes: Array<Types.ModuleType | null>;
			path: string;
			publicationDate?: string | null;
			breakingnewsEnd?: string | null;
			rowId: string;
			teaserText?: string | null;
			title: string;
			image?: {
				__typename?: 'ModuleImage';
				altText?: string | null;
				copyright?: string | null;
				title?: string | null;
				url?: string | null;
			} | null;
		} | null;
	}>;
};

export const SearchResultsFragmentDoc = gql`
	fragment SearchResults on ArticlesConnection {
		edges {
			node {
				...ArticleItemResultsItem
			}
		}
	}
	${ArticleItemResultsItemFragmentDoc}
`;
